<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_info_search') ||
                  '客户名称/疵点标准名称/适用范围 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              v-if="allow('A')"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_dfDefinitionNo') || '状态'">
              <el-checkbox-group v-model="form.listStatus">
                <el-checkbox label="N"> {{ '草稿' }}</el-checkbox>
                <el-checkbox label="Y"> {{ '已启用' }} </el-checkbox>
                <el-checkbox label="S">{{ '已停用' }} </el-checkbox>
                <el-checkbox label="D">{{ '已删除' }} </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_dfDefinitionName') || '标准名称'"
              prop="dfDefinitionName"
            >
              <el-input
                v-model="form.dfDefinitionName"
                :placeholder="
                  $l('form_label_pl_dfDefinitionName') || '请输入标准名称'
                "
                :maxlength="500"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_custName') || '适用客户'"
              prop="customerCode"
            >
              <el-select
                v-model="form.listCustomerCode"
                :placeholder="$l('form_label_pl_custName') || '请选择适用客户'"
                filterable
                multiple
                clearable
                style="width:100%"
              >
                <el-option
                  v-for="item in customerOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('form_label_productScopeDescription') || '适用产品说明'
              "
              prop="productScopeDescription"
            >
              <el-input
                v-model="form.productScopeDescription"
                :placeholder="
                  $l('form_label_pl_productScopeDescription') ||
                    '请输入适用产品说明'
                "
                :maxlength="50"
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_enableDate') || '启用日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.enableDateStart"
                    :placeholder="
                      $l('form_label_pl_enableDate') || '请选择启用日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.enableDateEnd"
                    :placeholder="
                      $l('form_label_pl_enableDate') || '请选择启用日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_disableDate') || '停用日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.disableDateStart"
                    :placeholder="
                      $l('form_label_pl_disableDate') || '请选择停用日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.disableDateEnd"
                    :placeholder="
                      $l('form_label_pl_disableDate') || '请选择停用日期'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="$l('form_label_displayCreate') || '创建人'">
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_label_pl_displayCreate') || '请选择创建人'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_createTime') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    :placeholder="
                      $l('form_label_pl_createTime') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    :placeholder="
                      $l('form_label_pl_createTime') || '请选择创建时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_displayModify') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_label_pl_displayModify') || '请选择修改人'
                "
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyTime') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    :placeholder="
                      $l('form_label_pl_modifyTime') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    :placeholder="
                      $l('form_label_pl_modifyTime') || '请选择修改时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/api/service'
// 初始表单
const initForm = { keyword: '', listStatus: ['N', 'Y', 'S'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      customerOptions: [],

      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
    this.getCust()
  },
  methods: {
    getCust() {
      //客户
      request({
        url: '/digitalCenter/common/dict/customer',
        method: 'post',
        data: {},
      }).then((res) => {
        this.customerOptions = res.body.data
        if (this.customerOptions) {
          this.customerOptions.splice(0, 0, { label: 'ALL', value: 'ALL' })
        } else {
          this.customerOptions = [{ label: 'ALL', value: 'ALL' }]
        }
      })
    },
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
